import script from "./BucketCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./BucketCreate.vue?vue&type=script&lang=ts&setup=true"

import "./BucketCreate.vue?vue&type=style&index=0&id=062b7312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-062b7312"]])

export default __exports__